import React, { useState, useCallback, useEffect } from 'react'
import Loading from '../common/Loading';
import { dashboardService } from '../../services';
import { Link } from 'react-router-dom';

const PoliciesAndClaimAmount = ({ filter }) => {

    const [policyClaimAmountDetails, setPolicyClaimAmountDetails] = useState({
        totalPolicies: 0,
        totalSumInsured: 0,
        totalClaimAmount: 0,
        totalClaimSettledAmount: 0,
        noOfActiveClaim: 0,
        totalActiveClaimAmount: 0
    });
    const [isLoading, setIsLoading] = useState(false);


    const fetchAmountData = useCallback(async () => {
        setIsLoading(true);
        const policyClaimAmountDetailsResponse = await dashboardService.fetchAmountData(filter);
        if (policyClaimAmountDetailsResponse?.isSuccess) {
            setPolicyClaimAmountDetails(policyClaimAmountDetailsResponse?.data?.[0]);
        }
        setIsLoading(false);
    }, [filter]);

    useEffect(() => {
        const fetchList = async () => {
            await fetchAmountData()
        }
        fetchList()
    }, [filter]);

    return (
        <div>
            <div >
                <div className='d-flex mb-3 d-flex  Claim_box_main_wrap text-center'>
                    <div className='Raised_Settled-Amountbox'>
                        <Link to={{
                            pathname: "/External/raise-claim",
                        }}
                            style={{ textDecoration: 'none' }}
                            state={{finYear: filter?.financialYear}}
                        >
                            <div className="fieldArrayBox dashboard_top_box box_four  ">
                                <div>
                                    <label className='top_box_title'>
                                        Settled / Claim Amount
                                    </label>
                                </div>
                                <div className='top_box_count'>
                                    {!isLoading ? policyClaimAmountDetails?.totalClaimSettledAmount || 0 : <Loading isHeightReq={false} />}
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
                <div className='row '>
                    <div className='col-md-12 col-12'>
                        {!isLoading ? <Link to={{
                            pathname: "/External/raise-claim",
                        }}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            state={{finYear: filter?.financialYear, divisionId: filter?.divisionId}}
                        ><div className='d-flex justify-content-center Claims_box_wrap' style={{ listStyle: 'none' }}>
                                <li className='me-3 Active_Claimstext'>Active Claims:</li>
                                <li className='Active_Claims'>{policyClaimAmountDetails?.noOfActiveClaim || 0}</li>
                                <li className='me-4 ms-4 Active_Claims' >|</li>
                                <li className='me-3 Claim_Amount Active_Claimstext'>Claim Amount:</li> <li className='Active_Claims'>{policyClaimAmountDetails?.totalActiveClaimAmount || 0}</li>
                            </div>
                        </Link> : <Loading isHeightReq={false} />}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default PoliciesAndClaimAmount